<template>
  <div class="pt-10">
    <v-row justify="center" align="center" v-if="!hasReflections">
      <v-col cols="10">
        <h4>
          {{ $t('views.reflection.emptyList') }}
        </h4>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" v-if="hasInProgressReflections">
      <v-col cols="10">
        <ReflectionCardIterator
          disable-pagination
          :items="inProgressReflections"
          back-to="reflections"
        />
      </v-col>
    </v-row>
    <v-row justify="center" align="center" v-if="hasCompletedReflections">
      <v-col cols="12">
        <h4>
          {{ $t('views.reflection.inProgress') }}
        </h4>
        <ReflectionCardIterator
          disable-pagination
          :items="completedReflections"
          back-to="reflections"
        />
      </v-col>
    </v-row>
    <span class="newReflectionButton">
      <NewReflectionModal
        :header="$t('views.reflection.create')" :loading="createInProgress"
        @redirect="onRedirect"
      >
        <template v-slot:button="{ activator }">
          <v-btn fab
                 color="primary"
                 v-bind="activator.attrs"
                 v-on="activator.on"
          >
            <v-icon class="material-icons" size="20">
              add
            </v-icon>
          </v-btn>
        </template>
      </NewReflectionModal>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReflectionCardIterator from '@/components/cards/ReflectionCardIterator';
import NewReflectionModal from '@/components/pages/reflections/NewReflectionModal';
import { types } from '@/store/rootTypes';

export default {
  name: 'Reflections',
  components: {
    NewReflectionModal,
    ReflectionCardIterator,
  },
  computed: {
    ...mapGetters({
      createInProgress: types.reflections.getters.createInProgress,
      reflections: types.reflections.getters.reflections,
    }),
    hasReflections() {
      return !!(this.reflections && this.reflections.length > 0);
    },
    inProgressReflections() {
      return this.hasReflections ? this.reflections.filter(reflection => reflection.status === 'IN_PROGRESS') : [];
    },
    completedReflections() {
      return this.hasReflections ? this.reflections.filter(reflection => reflection.status === 'COMPLETED') : [];
    },
    hasInProgressReflections() {
      return this.inProgressReflections.length > 0;
    },
    hasCompletedReflections() {
      return this.completedReflections.length > 0;
    },
  },
  methods: {
    onRedirect(id) {
      this.$router.push(`/reflections/${id}`);
    },
  },
};
</script>
<style>
.newReflectionButton {
  position: fixed;
  bottom: 62px;
  right: 30px;
}
</style>
